import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './SkeletonLoader.css';

interface SkeletonLoaderProps {
  count?: number;
  width?: number | string;
  height?: number | string;
  circle?: boolean;
  style?: React.CSSProperties;
  inline?: boolean;
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
  count = 1,
  width,
  height,
  circle = false,
  style,
  inline = false,
}) => (
  <Skeleton
    count={count}
    width={width}
    height={height}
    circle={circle}
    inline={inline}
    style={style}
  />
);

export default SkeletonLoader;
